import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full w-full" }
const _hoisted_2 = { class: "flex-grow overflow-auto w-full bg-trader-gray" }
const _hoisted_3 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_4 = ["onClick"]

import {computed, nextTick, ref, watch} from "vue";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'TRListe',
  props: {
  dataList: Array,
  searchInput: {
    type: String,
    required: false,
    default: "",
  },
  style: Object,
  selectedId: Number,
  formatCellValue: {
    type: Function,
    required: false,
    default: (dataRow: any, field: string) => {
      return dataRow[field];
    },
  },
  onSelectionChange: {
    type: Function,
    required: false,
    default: (rows: any[]) => {
    },
  },
  onPageStep: {
    type: Function,
    required: false,
    default: (step: number) => {
    },
  },
},
  setup(__props) {

const props = __props;

// Refs und Daten
const selectItem = ref(props.selectedId || null);
const selectItemValue = ref(null);
const refs = ref(new Map()); // Map für Referenzen

// Funktion zum Hinzufügen von Referenzen
function addRef(el, id) {
  if (el) refs.value.set(id, el); // Element zur Map hinzufügen
  else refs.value.delete(id); // Element aus der Map entfernen, wenn nicht mehr vorhanden
}

// Daten filtern
const filteredDataList = computed(() => {
  if (!props.searchInput || props.searchInput.trim() === "") {
    return props.dataList;
  } else {
    return props.dataList.filter((item) =>
        item.value.toLowerCase().includes(props.searchInput.toLowerCase())
    );
  }
});

// Element auswählen
function getSelectItem(data) {
  selectItemValue.value = data;
  selectItem.value = data.id;
  props.onSelectionChange(data); // Callback aufrufen
  scrollToItem(data.id); // Scrollen zum Element
}

// Scroll-Funktion
function scrollToItem(id) {
  nextTick(() => {
    const listItem = refs.value.get(id); // Element über Map abrufen
    if (listItem) {
      listItem.scrollIntoView({behavior: "smooth", block: "center"});
    }
  });
}

// Watcher, um auf Änderungen von selectedId zu reagieren
watch(
    () => props.selectedId,
    (newValue) => {
      selectItem.value = newValue;
      scrollToItem(newValue); // Scrollen bei externer Änderung
    },
    {immediate: true}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDataList.value, (data, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: data.id,
            ref_for: true,
            ref: el => addRef(el, data.id),
            class: _normalizeClass(["w-full p-1 border-trader-dark-gray", { 'bg-trader-blue text-trader-highlight': data.id == selectItem.value }]),
            onClick: ($event: any) => (getSelectItem(data))
          }, _toDisplayString(data.value), 11, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})